<template>
  <v-app id="app" class="app" v-show="isReady">

    <!-- this is a header of the site -->
    <transition name="scroll-x-transition" appear>
      <v-app-bar flat fixed :dark="dark" v-if="SiteSettings" class="pt-1 px-0 pt-md-6 px-md-4">
        <v-row align="start" justify="start"  no-gutters>
          <v-col cols="auto" class="shrink">
            <router-link data-cursor-target="camera|center center" :to="{name: 'Home', params: {language: $language.current}}" @click="menuOpen = false">
              <VogueLogo class="vogue-logo-svg" height="52" />
              <transition>
                <span v-if="$root.sponsorLogo && !menuOpen">
                  <CloseIcon class="d-inline-block px-2 sponsor-x" />
                  <!-- 45 : 70 = 33 : x -->
                  <v-img class="d-inline-block" :src="optimizedImageURL($root.sponsorLogo, {width: $vuetify.breakpoint.xs ? 51 : 82, height: $vuetify.breakpoint.xs ? 33 : 52})" contain :width="$vuetify.breakpoint.xs ? 51 : 82" :height="$vuetify.breakpoint.xs ? 33 : 52" position="0% 50%" />
                </span>
              </transition>
            </router-link>
          </v-col>
          <v-col cols="auto" class="grow text-center">
            <transition mode="out-in">
              <v-btn v-if="$root.siteSettings.igFilterLink && menuOpen" class="text-script red--text mx-auto" text :small="!$vuetify.breakpoint.xs" :x-small="$vuetify.breakpoint.xs" :href="$root.siteSettings.igFilterLink" target="_blank" rel="noopener" data-cursor-target="filter|center center">Filter</v-btn>
              <v-btn v-else-if="!menuOpen && globalCloseXOpen" class="mx-auto" text :small="!$vuetify.breakpoint.xs" :x-small="$vuetify.breakpoint.xs" @click="$events.emit('global-close-x:click')" >
                <CloseIcon style="fill: currentColor;" />
              </v-btn>
            </transition>
          </v-col>
          <v-col cols="auto" class="shrink">
            <v-btn :data-cursor-target="!menuOpen ? 'plus|center center' : 'plus|center center|1|45'" v-if="!SiteSettings.teaserMode" class="text-script" text :small="!$vuetify.breakpoint.xs" :x-small="$vuetify.breakpoint.xs" @click="menuOpen = !menuOpen">Menu</v-btn>
          </v-col>
        </v-row>
      </v-app-bar>
    </transition>

    <v-main>
      <transition>
        <template v-if="isReady">
          <router-view v-if="!SiteSettings.teaserMode" :key="`${$route.name}-${$route.params ? $route.params.slug : ''}`" />
          <TeaserPage v-else />
        </template>
      </transition>
    </v-main>
    <MainMenu v-model="menuOpen" v-if="isReady && !SiteSettings.teaserMode" />
    <CursorComponent v-if="!$root.platform.mobile" />
    <VersionInfo
      v-if="$root.process.env.SERVICE_STAGE !== 'production'"
      :version="$root.process.env.GIT_VERSION"
      :commit-hash="$root.process.env.GIT_COMMIT_HASH"
      />
  </v-app>
</template>

<script>
import { VersionInfo } from '@monogrid/vue-lib'
import { Platform } from '@monogrid/js-utils'
import shareImage from '@/assets/img/share.jpg'
import VogueLogo from '@/assets/img/vogue-logo.svg'
import MainMenu from '@/organisms/MainMenu'
import GetSiteSettings from '@/graphql/GetSiteSettings.gql'
import TeaserPage from '@/pages/TeaserPage'
import CursorComponent from '@/atoms/CursorComponent'
import CloseIcon from '@/assets/img/close-icon.svg'
import { optimizedImageURL } from '@/services/OptimizedImage'

let initializedModernizr = false

export default {
  name: 'App',

  components: {
    VersionInfo,
    VogueLogo,
    MainMenu,
    TeaserPage,
    CursorComponent,
    CloseIcon
  },

  data () {
    return {
      // this flag is used to show the app once the preloading
      // (if present) is finished
      isReady: false,
      globalCloseXOpen: false,
      menuOpen: false,
      // platform, accessible with an import statement
      // or by using this.$root.platform
      // NOTE: import statement is preferred
      platform: Platform
    }
  },

  mounted () {
    this.$events.on('global-close-x:hide', () => { this.globalCloseXOpen = false })
    this.$events.on('global-close-x:display', () => { this.globalCloseXOpen = true })
  },

  updated () {
    // if not prerenderer
    if (!Platform.prerenderer && window.Modernizr && !initializedModernizr) {
      // add custom modernizr tests
      initializedModernizr = true
      // window.Modernizr.addAsyncTest('avif', this.testAvif)
      for (const key in Platform) {
        window.Modernizr.addTest(key, () => {
          return Platform[key]
        })
      }
    }
  },
  methods: {
    optimizedImageURL
  },
  computed: {
    dark () {
      return this.$route.meta && typeof this.$route.meta.isDark === 'function' && this.$route.meta.isDark(this.$route.params) && !this.menuOpen
    }
    // sponsorLogo () {
    //   if (this.$route.meta && typeof this.$route.meta.sponsorLogo === 'function' && !this.menuOpen) {
    //     return this.$route.meta.sponsorLogo(this)
    //   }
    //   return null
    // }
  },
  apollo: {
    SiteSettings: {
      query: GetSiteSettings,
      variables () {
        return {
          status: 'PUBLISHED',
          slug: this.$language.current
        }
      },
      result (value) {
        this.isReady = true
        this.$root.siteSettings = this.SiteSettings
        // this.$root.siteSettings.liveNow = false
        // this.$root.siteSettings.teaserMode = true
      }
    }
  },
  watch: {
    menuOpen (value) {
      this.$root.otButtonInstance.visible = value
    },
    isReady (value) {
      // hide / show preloader
      this.$root.preloader.visible = !value
    },
    dark (value) {
      this.$vuetify.theme.dark = value
    }
  },

  metaInfo () {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: ' ',
      // all titles will be injected into this template
      titleTemplate: '%s | PhotoVogue Festival 2020',
      base: { href: '/' },
      meta: [
        { 'http-equiv': 'X-UA-Compatible', content: 'IE=edge' },
        { name: 'apple-mobile-web-app-capable', content: 'yes' },
        { name: 'mobile-web-app-capable', content: 'yes' },
        // twitter
        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:site', content: '@monogridstudio' },
        { name: 'twitter:creator', content: '@monogridstudio' },
        // generic description
        { vmid: 'description', name: 'description', content: 'The first conscious fashion photography festival that focuses on the common ground between ethics and aesthetics.' },
        // og tags
        { vmid: 'ogtype', property: 'og:type', content: 'website' },
        { vmid: 'ogurl', property: 'og:url', content: 'https://' + this.$root.process.env.SERVICE_TARGET_DOMAIN + '/' + this.$route.fullPath },
        { vmid: 'ogtitle', property: 'og:title', itemprop: 'name', content: 'PhotoVogue Festival 2020' },
        { vmid: 'ogdescription', property: 'og:description', content: 'The first conscious fashion photography festival that focuses on the common ground between ethics and aesthetics.' },
        { vmid: 'ogimage', property: 'og:image', content: 'https://' + this.$root.process.env.SERVICE_TARGET_DOMAIN + shareImage },
        { vmid: 'ogimagetype', property: 'og:image:type', content: 'image/jpeg' },
        { vmid: 'ogimageheight', property: 'og:image:width', content: '1200' },
        { vmid: 'ogimagewidth', property: 'og:image:height', content: '675' }
      ]
    }
  }
}
</script>

<style lang="scss">
@import './assets/scss/typography';
@import './assets/scss/utils';

html {
  overflow-y: auto !important;
}

a {
  text-decoration: none;
  color: currentColor;

  &:visited,
  &:active,
  &:focus,
  &:hover {
    color: currentColor;
  }
}

::selection {
  color: map-get($shades, 'white');
  background: map-deep-get($colors, 'red', 'base');
}

// html {
//   -webkit-font-smoothing: auto;
//   text-rendering: unset;
// }
// hide button backgrounds
.v-btn {
  letter-spacing: 0;

  &::before {
    background-color: transparent !important;
  }

  .v-btn__content {
    text-transform: none;
  }
}

[data-cursor-target*='|']:not(.no-hover-fade) {
  transition: opacity 0.5s;

  &:hover {
    opacity: 0.4;
  }
}

.paper-background {
  background-image: url('./assets/img/paper-bg.jpg');
  background-size: 100%;
  background-position: center top;
  background-repeat: repeat-y;
}

.taped {
  &::before {
    content: '';
    background-image: url('./assets/img/artists/tape.png');
    width: 149px;
    height: 74px;
    position: absolute;
    left: 50%;
    top: 0;
    transform: translate3d(-50%, -50%, 0);
    background-size: 100% 100%;
  }

  &--rotated {
    &::before {
      transform: translate3d(-50%, -50%, 0) rotate(-5deg);
    }
  }
}

.next-icon {
  width: 92px * 0.8;
  height: 93.3px * 0.8;
  fill: currentColor;
}

.justify-content-left {
  justify-content: left;
}

.justify-content-right {
  justify-content: right;
}

.theme--light.v-btn.v-btn--icon {
  color: map-get(map-get($material-light, 'text'), 'primary');
}

.theme--light.v-btn:hover::before {
  opacity: 1 !important;
}

.v-ripple__animation {
  opacity: 0 !important;
}

.fill-height {
  height: 100%;
}

.shrink {
  flex-shrink: 1 !important;
  flex-grow: 0 !important;
}

.grow {
  flex-shrink: 0 !important;
  flex-grow: 1 !important;
}

.o-hidden {
  overflow: hidden;
}

.bottom-left-btn {
  position: fixed !important;
  bottom: 30px;
  left: 30px;

  @include breakpoint('xs-only') {
    bottom: 25px;
    left: 15px;
  }
}

.bottom-center-btn {
  position: fixed !important;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);

  @include breakpoint('xs-only') {
    bottom: 25px;
  }
}

.bottom-right-btn {
  position: fixed !important;
  bottom: 30px;
  right: 30px;
  @include breakpoint('xs-only') {
    bottom: 25px;
    right: 15px;
  }
}

.top-center-btn {
  position: fixed !important;
  top: 30px;
  left: 50%;
  transform: translateX(-50%);

  @include breakpoint('xs-only') {
    top: 20px;
  }
}

.btn-break-spaces {
  .v-btn__content {
    max-width: 100%;
    text-align: left;
    white-space: break-spaces;
  }
}

// generic transition for when <transition> tag is used
.v-enter-active,
.v-leave-active {
  .no-prerenderer & {
    transition: opacity 0.3s $ease-in-out-quad;
  }
}

.v-enter,
.v-leave-to {
  opacity: 0;
}

.theme--light.v-app-bar,
.theme--dark.v-app-bar {
  background-color: transparent !important;
  pointer-events: none;

  a,
  button {
    pointer-events: all;
  }
}

.theme--light.v-app-bar {
  @include breakpoint('sm-and-down') {
    // background-color: rgba(244, 243, 241, 0.6) !important;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 150%;
      background: rgb(20, 20, 20);
      background: linear-gradient(180deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0.36) 40%, rgba(255, 255, 255, 0) 100%);
      pointer-events: none;
    }
  }
}

.theme--dark.v-app-bar {
  @include breakpoint('sm-and-down') {
    // background-color: rgba(0, 0, 0, 0.9) !important;
    // background: rgb(20, 20, 20);
    // background: linear-gradient(180deg, rgba(20, 20, 20, 1) 0%, rgba(20, 20, 20, 0) 100%);

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 150%;
      background: rgb(20, 20, 20);
      background: linear-gradient(180deg, rgba(20, 20, 20, 1) 0%, rgba(20, 20, 20, 0.86) 40%, rgba(20, 20, 20, 0) 100%);
      pointer-events: none;
    }
  }
}

.vogue-logo-svg {

  @include breakpoint('sm-and-down') {
    width: 50.6px;
    height: 33px;
  }
  // width: 80px * 1.2;
  // height: 20px * 1.2;

  path {
    transition: fill 0.25s;
    fill: currentColor;
  }
}

.copy-top {
  &::before {
    content: attr(data-copy);
    position: fixed;
    top: -1vh;
    left: 50%;
    transform: translateX(-50%);
    font-size: 8vw;
    font-family: 'BrotherHome', serif;
    font-weight: normal !important;
    letter-spacing: 0.2em !important;
    line-height: 2.2em;
    color: #000;
    width: 1000%;
    text-align: center;
    opacity: 0.05;
  }
}

.sponsor-x {
  height: 52px;
  width: 35px;
  fill: map-deep-get($colors, 'red', 'base');
  margin-left: 21px;
  margin-right: 15px;

  @include breakpoint('sm-and-down') {
    height: 33px; // 33 : 45 : x : 35
    width: 25.6px;
    margin-left: 5px;
    margin-right: 0;
  }
}

// vue plyr controls

.plyr--full-ui input[type=range] {
  color: rgba(0, 0, 0, 0.1) !important;
}

.plyr__control:hover {
  background: rgba(0, 0, 0, 0.1) !important;
}

.plyr__control--overlaid {
  background: rgba(0, 0, 0, 0.1) !important;
  width: 100px !important;
  height: 100px !important;

  svg {
    width: 100% !important;
    height: 100% !important;
  }
}

.v-application .display-2 {
  @include breakpoint('xs-only') {
    font-size: 1.75rem !important;
    line-height: 2.71 !important;
    letter-spacing: 0.2625rem !important;
  }
}

.v-application .display-4 {
  @include breakpoint('xs-only') {
    font-size: 3.0625rem !important;
    line-height: 1.08 !important;
  }
}

.v-application .headline {
  @include breakpoint('xs-only') {
    font-size: 1.5rem !important;
    line-height: 1.17 !important;
  }
}

.v-application .subtitle-1 {
  @include breakpoint('xs-only') {
    font-size: 1.4375rem !important;
    line-height: 1.26 !important;
  }
}

</style>
